import { useEffect, useState } from "react";

export default function useInfiniteScroll(offsetFromBottom: number) {
    const [hasReachedEnd, setReachedEnd] = useState(false);

    useEffect(() => {
        function handleScroll() {
            setReachedEnd(
                window.innerHeight + window.scrollY >=
                    document.body.offsetHeight - offsetFromBottom
            );
        }

        const listener = window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return hasReachedEnd;
}
